import React, { useMemo } from "react";
import { Autocomplete, Box, TextField, Typography, createFilterOptions } from "@mui/material";
import { getConditionContextVariables, getVariablesByGroup } from "./chatbotContextVariables";

const filter = createFilterOptions({
  stringify: (opt) =>
    [opt.name, opt.messageVar, opt.label, opt.group, opt.name ? `$${opt.name}` : ""]
      .filter(Boolean)
      .join(" "),
});

export function buildContextVariableOptions() {
  const { groupLabels } = getVariablesByGroup();
  return getConditionContextVariables().map((v) => ({
    name: v.key,
    label: v.label,
    group: groupLabels[v.group] || v.group,
    messageVar: v.messageVar,
  }));
}

export default function ContextVariableAutocomplete({
  value,
  onChange,
  label = "Variável",
  placeholder = "Buscar variável...",
  disabled = false,
  sx,
}) {
  const options = useMemo(() => buildContextVariableOptions(), []);
  const selected = options.find((o) => o.name === String(value || "").toLowerCase()) || null;

  return (
    <Autocomplete
      size="small"
      disabled={disabled}
      options={options}
      value={selected}
      onChange={(_, opt) => onChange(opt?.name || "")}
      groupBy={(opt) => opt.group || ""}
      getOptionLabel={(opt) => (opt?.label ? `${opt.label}` : "")}
      isOptionEqualToValue={(a, b) => a.name === b.name}
      filterOptions={filter}
      noOptionsText="Nenhuma variável encontrada"
      renderOption={(props, opt) => (
        <li {...props} key={opt.name}>
          <Box sx={{ py: 0.25, maxWidth: "100%" }}>
            <Typography variant="body2" noWrap>
              {opt.label}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontFamily: "monospace" }}
              noWrap
              display="block"
            >
              {opt.messageVar || `$${opt.name}`}
            </Typography>
          </Box>
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} />
      )}
      slotProps={{
        popper: { sx: { zIndex: (theme) => theme.zIndex.modal + 2 } },
        listbox: { sx: { maxHeight: 320 } },
      }}
      sx={{ minWidth: 200, flex: 1, ...sx }}
    />
  );
}
